<div class="qrscanner" [class.--show]="scanerVisible">
  <video #video class="qrscanner__video --{{ cameraPosition }}" autoplay></video>
  <canvas #canvas class="qrscanner__canvas"></canvas>
</div>
